import React, { useContext, useMemo, useReducer } from 'react';
import { useWidget } from 'state/widget/context';
import { DEFAULT_DISPLAY_UNITS_STATE } from './constants';
import reducer from './reducer';
import { DisplayUnitsContextType, DisplayUnitsProviderProps } from './types';
import getDisplayUnits from './utils';

const DisplayUnitsContext = React.createContext<
  DisplayUnitsContextType | undefined
>(undefined);

export const DisplayUnitsProvider: React.FC<DisplayUnitsProviderProps> = ({
  children,
}) => {
  const {
    state: { expectedNumberOfUnits, unitOrder },
  } = useWidget();
  const [state, dispatch] = useReducer(reducer, DEFAULT_DISPLAY_UNITS_STATE);

  const displayUnits = useMemo(
    () =>
      getDisplayUnits({
        ...state,
        expectedNumberOfUnits,
        unitOrder,
      }),
    [expectedNumberOfUnits, state, unitOrder],
  );

  return (
    <DisplayUnitsContext.Provider
      value={useMemo(
        () => ({
          dispatch,
          displayUnits,
        }),
        [displayUnits],
      )}
    >
      {children}
    </DisplayUnitsContext.Provider>
  );
};

export function useDisplayUnits() {
  const context = useContext(DisplayUnitsContext);

  if (context === undefined) {
    throw new Error('useDisplayUnits must be used within DisplayUnitsProvider');
  }

  return context;
}
